/* Used by Storefront */
import React, { useState, useEffect } from "react";
interface Props {
  visibleText?: string;
  hideHiddenText: boolean;
  visibleMarkup?: string;
  overflowText?: string;
}
const VisibleHiddenText = ({
  visibleText,
  hideHiddenText,
  overflowText = "",
  visibleMarkup = ""
}: Props) => {
  const [showHiddenText, setShowHiddenText] = useState(!hideHiddenText);
  const [showReadMoreText, setShowReadMoreText] = useState(hideHiddenText);
  const [readMoreClicked, setReadMoreClicked] = useState(false);
  const handleReadMoreClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.preventDefault();
    setShowHiddenText(true);
    setShowReadMoreText(false);
    setReadMoreClicked(true);
  };

  // TODO: Remove this workaround once Catalog stops sending an extra tag.
  function pruneExtraDiv(text: string): string {
    const tag = "<div>";
    return text.endsWith(tag) ? text.substr(0, text.length - tag.length) : text;
  }
  useEffect(() => {
    const focusTarget = document.getElementById("newest-paragraph");
    if (focusTarget) {
      focusTarget.focus();
    }
  }, [readMoreClicked]);
  return <>
      {visibleText && <>
          <div style={{
        display: "contents"
      }} className="visible-content"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{
        __html: visibleText
      }} />
          {showReadMoreText && (visibleMarkup || overflowText) && <button type="button" onClick={e => handleReadMoreClick(e)} className="border-none bg-transparent p-0 text-green-600 inline ml-1 mt-0 font-semibold resources__text hover:underline hover:text-green-700">
              Read more
            </button>}
        </>}
      {overflowText && <div id={readMoreClicked ? "newest-paragraph" : undefined}
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    tabIndex={readMoreClicked ? -1 : undefined} style={{
      marginTop: "16px"
    }} className={`${!showHiddenText ? "hide" : ""}`}
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{
      __html: overflowText
    }} />}
      {visibleMarkup && <div className={`${!showHiddenText ? "hide" : ""}`}
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{
      __html: pruneExtraDiv(visibleMarkup)
    }} />}
    </>;
};
export default VisibleHiddenText;